import Component from './form-failure';
export default Component;
